export const ADDRESSES_FETCH = "ADDRESSES_FETCH";
export const ADDRESSES_FETCH_SUCCESS = "ADDRESSES_FETCH_SUCCESS";
